import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useLogin } from '../../hooks/useLogin'

// styles
import './Zugang.css'
import AddTopSpace from '../../components/AddTopSpace'
import AddBottomSpace from '../../components/AddBottomSpace'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { login, error } = useLogin()
  
  const handleSubmit = (e) => {
    e.preventDefault()
    login(email, password)
  }

  return (
    <>
      <AddTopSpace />
      <div className="container py-3">
        <div className="row">
          <div className="col d-flex justify-content-center">
            <main className="form-signin w-100 m-auto">
              <form onSubmit={handleSubmit} className="login-form">
                <p className="h3 mb-3 fw-normal">Please log in</p>
                <div className="form-floating">
                  <input 
                    className="form-control" 
                    id="floatingInput" 
                    placeholder="name@example.com"
                    type="email" 
                    onChange={(e) => setEmail(e.target.value)} 
                    value={email}
                  />
                  <label htmlFor="floatingInput">Email address</label>
                </div>
                <div className="form-floating my-3">
                  <input 
                    className="form-control" 
                    id="floatingPassword" 
                    placeholder="Password"
                    type="password" 
                    onChange={(e) => setPassword(e.target.value)} 
                    value={password}
                  />
                  <label htmlFor="floatingPassword">Password</label>
                </div>
                <button className="btn btn-success">Log in</button>
                &nbsp;&nbsp;
                <Link to="/">
                  <button className="btn btn-danger">Cancel</button>
                </Link>
                {error && 
                  <div className="container py-3">
                    <div className="row">
                      <div className="col d-flex justify-content-center">
                        <div className="alert alert-danger">{error}</div>
                      </div>
                    </div>
                  </div>
                }
              </form>
            </main>
          </div>
        </div>
        <div className="row">
          <div className="col d-flex justify-content-center">

           
          </div>
        </div>
        <div className="row">
          <div className="col d-flex justify-content-center">


          </div>
        </div>

      </div>
      <AddBottomSpace />
      <AddBottomSpace />
    </>
  )
}